<template>
    <div class="speakers">
        <div class="speakers__speakers">
            <div v-for="speaker in currentSpeakers" class="speakers__speaker">
                <div class="speaker-card" v-on:click="setSpeaker(speaker)" v-bind:class="{'speaker-card--dark': theme == 'dark'}">
                    <div v-if="speaker.webPhoto" class="speaker-card__cover" v-bind:style="{ backgroundImage: 'url(' + speaker.webPhoto + ')' }"></div>
                    <div v-else class="speaker-card__cover"></div>
                    <div class="speaker-card__name">
                        {{ speaker.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import axios from 'axios'
    import dateFormat from 'dateformat'
    import transitionToFromAuto from 'transition-to-from-auto'
    import ScheduleSwitcher from './ScheduleSwitcher.vue'

    export default {

        components: {
            ScheduleSwitcher
        },

        props: {
            order: {
                default: 'alphabetical'
            },
            speakers: null,
            sessions: null,
            limit: {
                default: false
            },
            breakoutTracks: null,
            timeslots: null,
            theme: {
                default: 'light'
            },
            type: null
        },

        data: function() {
            return {
                currentSpeakers: null,
                speaker: null,
                speakerSessions: [],
            }
        },

        methods: {
            setSpeakers: function() {
                var self = this;
                var speakerData = JSON.parse(JSON.stringify(this.speakers));

                if(this.order == 'alphabetical') {
                    function compareAlphabetical(a,b) {
                        if (a.name < b.name)
                            return -1;
                        if (a.name > b.name)
                            return 1;
                        return 0;
                    }

                    this.currentSpeakers = speakerData.sort(compareAlphabetical);
                } else {
                    function compare(a,b) {
                        if(!a.displayOrder || a.displayOrder == '0')
                            return 1;
                        if (a.displayOrder < b.displayOrder)
                            return -1;
                        if (a.displayOrder > b.displayOrder)
                            return 1;
                        return 0;
                    }
                    this.currentSpeakers = speakerData.sort(compare);
                }


                if (this.type != 'all'){
                    var filteredSpeakers = this.currentSpeakers.filter(item => {
                        return item.speakerType.indexOf(self.type) > -1
                    });

                    this.currentSpeakers = filteredSpeakers;
                }

                if(this.limit) {
                    this.currentSpeakers = this.currentSpeakers.slice(0, this.limit);
                }
            },

            setSpeaker: function(speaker) {
                this.speaker = speaker;
                this.$parent.currentModalComponent = 'ScheduleModal';
                this.$parent.modalArguments = {
                    scheduleSwitcherView: 'speaker',
                    timeslots: this.timeslots,
                    sessions: this.sessions,
                    speakers: this.speakers,
                    breakoutTracks: this.breakoutTracks,
                    speaker: this.speaker
                };
                this.$parent.showModal = true;
                document.body.classList.add("modal-open");
            },

            beforeLeave: function(el) {
                transitionToFromAuto({
                    element: el,
                    prop: 'height',
                    val: 0
                });
            },

            afterLeave: function(el) {
                this.showSpeaker = true;
            },

            speakerBeforeEnter: function(el) {
                el.style.height = 0;
                transitionToFromAuto({
                    element: el,
                    prop: 'height',
                    val: 'auto'
                });
            },

            speakerBeforeLeave: function(el) {
                transitionToFromAuto({
                    element: el,
                    prop: 'height',
                    val: 0
                });
            },

            closeScheduler: function() {
                this.speaker = null;
            },
        },


        watch: {
            speakers: function(val) {
                this.setSpeakers();
            }
        }

    }
</script>


// WEBPACK FOOTER //
// Speakers.vue?16623210